






import { Component, Vue, Watch } from 'vue-property-decorator';
import JobTable from '@/components/job/JobTable.vue';
import TopBar from '@/components/menu/TopBar.vue';
import { Getter, Action } from 'vuex-class';
import { Job } from '@/models/job.interface';
import { PaginatedPayload, PaginationInfo } from '@/models/util.interface';

@Component({
  components: {
    JobTable,
    TopBar,
  },
})
export default class JobList extends Vue {
  @Getter public jobs!: Job[];
  @Action('getJobsAction') public getJobsAction!: (payload?: PaginatedPayload) => void;
  @Action('changeJobPageAction') public changeJobPageAction!: (id: number) => void;
  @Getter private jobPage!: number;

  public fetchJobs(): void {
    this.getJobsAction({page: this.jobPage});
  }

  public onRemoveJob(id: string): void {
    if (this.jobs.length === 0 && this.jobPage > 1) {
      this.changeJobPageAction(this.jobPage - 1);
    } else {
      this.fetchJobs();
    }
    this.$notify({text: `Offre d'emploi supprimée avec succès`, type: 'success'});
  }

  private mounted() {
    this.jobPage !== 1 ? this.changeJobPageAction(1) : this.getJobsAction();
  }

  @Watch('jobPage')
  private onJobPaginationChanged(value: number, oldValue: number): void {
    this.fetchJobs();
  }
}
